class State {
  constructor() {
    this.siteSearchOpen = false;
    this.siteNavOpen = false;
    this.scrollMin = false;
    this.scrollDirection = null;
    this.jobApplicationFormOpened = false;
  }

  dispatch(type, value = null) {
    switch (type) {
      case "SITE_SEARCH":
        this.siteSearchOpen = value;
        break;
      case "SITE_NAV":
        this.siteNavOpen = value;
        break;
      case "SCROLL_MIN":
        this.scrollMin = value;
        break;
      case "SCROLL_DIRECTION":
        this.scrollDirection = value;
        break;
      case "JOB_APPLICATION_FORM": 
        this.jobApplicationFormOpened = value;
        break;
      case "RESET":
        this.siteSearchOpen = false;
        this.siteNavOpen = false;
        this.scrollMin = false;
        this.scrollDirection = null;
        this.jobApplicationFormOpened = false;
        break;
      default:
        break;
    }
  }
}

export const STATE = new State();
export default State;
